export default {
  minHeight: '200px',
  language: 'en_US',
  useCommandShortcut: true,
  useDefaultHTMLSanitizer: true,
  codeBlockLanguages: ['js', 'json'],
  usageStatistics: false,
  hideModeSwitch: true,
  toolbarItems: [ 'heading',
    'bold',
    'italic',
    'strike',
    'divider',
    'hr',
    'quote',
    'divider',
    'ul',
    'ol',
    'task',
    'divider',
    'table',
    'image',
    'link',
    'divider',
    'code',
    'codeblock'],
  placeholder: 'Write here'
}
